import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import AppRadio from "../../atoms/form/AppRadio";

interface ReportMessageBoardDialogProps {
  isOpen: boolean;
  onClose: () => void;
  handleReport: (reason: string) => void;
}

const options = [
  { label: "スパム", value: "スパム" },
  { label: "虚偽の情報", value: "虚偽の情報" },
  { label: "個人情報の掲載", value: "個人情報の掲載" },
  { label: "誹謗中傷", value: "誹謗中傷" },
  {
    label: "その他、不適切な投稿／コメント",
    value: "その他、不適切な投稿／コメント",
  },
];

const ReportMessageBoardDialog: React.FC<ReportMessageBoardDialogProps> = ({
  isOpen,
  onClose,
  handleReport,
}) => {
  const [reportReason, setReportReason] = React.useState<string>(
    options[0].value
  );
  const handleClose = () => {
    setReportReason(options[0].value);
    onClose();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-report-title"
      aria-describedby="alert-dialog-report-description"
      className={STBoardDetail.dialog}
    >
      <DialogContent>
        <DialogTitle
          className={STBoardDetail.dialogTitle}
          id="alert-dialog-report-title"
        >
          投稿の報告
        </DialogTitle>
        <DialogContentText
          className={STBoardDetail.dialogDescription}
          id="alert-dialog-report-description"
        >
          利用規約やガイドラインに違反する疑いがある投稿を発見された場合は、こちらより該当する理由を選択の上報告ください。
        </DialogContentText>

        <AppRadio
          name="report-reason"
          options={options}
          selectedValue={reportReason}
          onChange={(value) => setReportReason(value)}
          className={STBoardDetail.radioGroup}
        />
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "center" }}
        className={STBoardDetail.buttonGroup}
      >
        <Button className={STBoardDetail.backButton} onClick={handleClose}>
          キャンセル
        </Button>
        <Button
          className={STBoardDetail.submitButton}
          onClick={() => handleReport(reportReason)}
        >
          報告する
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportMessageBoardDialog;
